__webpack_require__.p = "https://now.bdstatic.com/store/v2/1996099/ticket-plat-frontend/7108e59/";